<template>
  <div class="footer">
    <footer class="pb-5 text-center">
      <!-- <b-button
        href="https://github.com/roshansaganti/crawliday"
        target="_blank"
        variant="none"
      >
        <font-awesome-icon class="theme-icon" :icon="['fab', 'github']" size="xl" />
      </b-button> -->
      <br /><br />
      <div class="text-muted small">
        &copy; Roshan Saganti. All Rights Reserved. 2024.
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
